export const MENU_TYPE="MENU_TYPE";
export const SET_LOADING = 'SET_LOADING';

export const SETRESET_ACTION = "SETRESET_ACTION";
export const CHECKIN_REPRINT_TOCKEN="CHECKIN_REPRINT_TOCKEN";
export const SELECTED_APPOIN_TYPE = "SELECTED_APPOIN_TYPE";

export const MOBILENUMBER = "MOBILENUMBER";

export const PRINT_TOCKEN_REQUEST="PRINT_TOCKEN_REQUEST";
export const PRINT_TOCKEN_RESPONSE="PRINT_TOCKEN_RESPONSE";

export const REPRINT_TOCKEN_REQUEST="REPRINT_TOCKEN_REQUEST";
export const REPRINT_TOCKEN_RESPONSE="REPRINT_TOCKEN_RESPONSE";

export const KIOSK_ID_AND_GET_MENUS_DATA_REQUEST = 'KIOSK_ID_AND_GET_MENUS_DATA_REQUEST';
export const KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE = 'KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE';

export const MOBILE_VERIFICATION_REQUEST="MOBILE_VERIFICATION_REQUEST";
export const MOBILE_VERIFICATION_RESPONSE="MOBILE_VERIFICATION_RESPONSE";

export const EMIRATES_VERIFICATION_REQUEST="EMIRATES_VERIFICATION_REQUEST";
export const EMIRATES_VERIFICATION_RESPONSE="EMIRATES_VERIFICATION_RESPONSE";

export const QRCODE_VERIFICATION_REQUEST="QRCODE_VERIFICATION_REQUEST";
export const QRCODE_VERIFICATION_RESPONSE="QRCODE_VERIFICATION_RESPONSE";

export const EMIRATESID_REQUEST="EMIRATESID_REQUEST";
export const EMIRATESID_RESPONSE="EMIRATESID_RESPONSE";

export const APPOINTMENTS_REQUEST="APPOINTMENTS_REQUEST";
export const APPOINTMENTS_RESPONSE="APPOINTMENTS_RESPONSE";


export const GENERATE_CHECKIN_TOKEN_REQUEST="GENERATE_CHECKIN_TOKEN_REQUEST";
export const GENERATE_CHECKIN_TOKEN_RESPONSE="GENERATE_CHECKIN_TOKEN_RESPONSE";

export const GENERATE_OTHERSERVICES_TOKEN_REQUEST="GENERATE_OTHERSERVICES_TOKEN_REQUEST";
export const GENERATE_OTHERSERVICES_TOKEN_RESPONSE="GENERATE_OTHERSERVICES_TOKEN_RESPONSE";

export const GET_CURRENT_TIME_REQUEST="GET_CURRENT_TIME_REQUEST";
export const GET_CURRENT_TIME_RESPONSE="GET_CURRENT_TIME_RESPONSE";



export const GET_PROMOTIONAL_FILES_REQUEST = "GET_PROMOTIONAL_FILES_REQUEST";
export const GET_PROMOTIONAL_FILES_RESPONSE = "GET_PROMOTIONAL_FILES_RESPONSE";

export const CHANGE_LANGUGAE = "CHANGE_LANGUGAE";


export const SET_LOGIN_PAGE = "SET_LOGIN_PAGE";








